module.exports = __webpack_public_path__ + "img/loader.ac93eb15.svg";